import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { arrayMoveImmutable as arrayMove } from 'array-move';
import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import { infoCategoriesRequest } from '../../actions';
import { selectInfoCategories } from '../../selectors';
import types from '../../actionTypes';

const { takeEvery, put, select } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    const infoCategories = yield select(selectInfoCategories);
    const orderedCategories = arrayMove(infoCategories, meta.oldIndex, meta.newIndex);

    const batch = firestore.batch();

    try {
        for (const lang of config.app.languages) {
            for (let index = 0; index < orderedCategories.length; index += 1) {
                if (orderedCategories[index]) {
                    const { id } = orderedCategories[index];
                    const ref = yield firestore.doc(`languages/${lang}/infoCategories/${id}`);
                    batch.update(ref, {
                        order: index,
                    });
                }
            }
        }
        yield batch.commit();
        yield put(infoCategoriesRequest({ silent: true }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.infoCategory.order' }));
    }
}
export default function* () {
    yield takeEvery(types.UPDATE_INFO_CATEGORY_ORDER, handler);
}
